import { TableCell, Chip } from '@mui/material';
import PersonIcon from '@mui/icons-material/Person';

const UserRoleCell = (props) => {
  const { roles } = props;
  const user_roles = roles.map((role) => {
    return role ? role : 'user'
  })
  const colors = {
    'admin': 'error',
    'developer': 'info',
    'user': 'success',
  }
  return (
    <TableCell>
      {user_roles.map((role, i) => {
        return (
          <Chip
            key={role}
            icon={<PersonIcon />}
            label={role}
            color={colors[role]}
            sx={{
              marginRight: i !== roles.length - 1 ? 1 : 0,
              textTransform: 'capitalize',
            }}
          />
        );
      })}
    </TableCell>
  );
};

export default UserRoleCell;
